<template>
    <div>
        <v-container grid-list-xl pt-0>
            <page-tool-bar show_search :loading="loader" :search.sync="search" :disabled="loader">
                <v-flex xs12 md2>
                    <div style="max-width: 290px" class="mr-3">
                        <v-menu :close-on-content-click="false" v-model="menu_month_picker" :nudge-right="40" lazy
                            transition="scale-transition" offset-y full-width min-width="290px" max-width="290px"
                            :disabled="loader">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" v-model="selectedMonth" label="Chọn tháng" prepend-icon="event"
                                    readonly hide-details :loading="loader" :disabled="loader"></v-text-field>
                            </template>
                            <v-date-picker locale="vi-VI" type="month" v-model="selectedMonth" :disabled="loader"
                                :loading="loader" @input="menu_month_picker = false"></v-date-picker>
                        </v-menu>
                    </div>
                </v-flex>
                <v-flex xs12 md2>
                    <div class="text-right d-flex align-center">
                        <v-select v-model="billType" :items="['Điện', 'Nước']" label="Chọn loại hóa đơn" outlined dense
                            hide-details class="mr-3" :loading="loader" :disabled="loader"></v-select>
                    </div>
                </v-flex>
                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="exportDataToCSV" color="primary" dark :loading="loader" :disabled="loader">XUẤT
                            CSV</v-btn>
                    </div>
                </v-flex>
            </page-tool-bar>

            <div style="width: 100%; gap: 8px;">
                <v-textarea :key="textareaKey" v-model="notes" placeholder="Nhập ghi chú..." dense rows="2" auto-grow border="1"
                    style="flex: 1;"></v-textarea>

                <v-btn color="primary" @click="saveNotes">
                    Lưu ghi chú
                </v-btn>
            </div>


            <h4 class="mt-4 text-center">BẢNG SO SÁNH TIỀN {{ billType.toUpperCase() }} 3 THÁNG
                <span v-if="selectedMonth">
                    (Tháng {{ formatMonth(twoMonthsAgo) }}/{{ moment(twoMonthsAgo).format('YYYY') }} - Tháng {{
                    formatMonth(previousMonth) }}/{{ moment(previousMonth).format('YYYY') }} - Tháng {{
                    formatMonth(selectedMonth)
                    }}/{{ moment(selectedMonth).format('YYYY') }})
                </span>
            </h4>

            <v-layout justify-center align-center v-if="loader" style="min-height:200px">
                <v-progress-circular indeterminate color="primary" size="50" />
            </v-layout>

            <div v-else class="table-container">
                <v-data-table :items="displayingItems" hide-headers hide-actions>
                    <template slot="items" slot-scope="props">
                        <template v-if="props.item.isFirstHeaderRow">
                            <tr class="text-no-wrap sticky-header">
                                <td class="text-xs-center font-weight-bold" rowSpan="2">TÒA NHÀ</td>
                                <td class="text-xs-center font-weight-bold" rowSpan="2">Mã KH</td>
                                <td class="text-xs-center font-weight-bold" colSpan="4">SỐ LƯỢNG TIÊU THỤ</td>
                                <td class="text-xs-center font-weight-bold" colSpan="5">CHÊNH LỆCH</td>
                            </tr>
                            <tr class="text-wrap">
                                <td class="text-xs-center font-weight-bold" style="min-width: 100px; max-width: 100px;">
                                    Tháng {{ formatMonth(twoMonthsAgo) }}</td>
                                <td class="text-xs-center font-weight-bold" style="min-width: 100px; max-width: 100px;">
                                    Tháng {{ formatMonth(previousMonth) }}</td>
                                <td class="text-xs-center font-weight-bold" style="min-width: 100px; max-width: 100px;">
                                    Tháng {{ formatMonth(selectedMonth) }}</td>
                                <td class="text-xs-center font-weight-bold" style="min-width: 120px; max-width: 120px;">
                                    Trung bình 3 tháng gần nhất</td>
                                <td class="text-xs-center font-weight-bold"
                                    style="background-color: #FCD6CC; min-width: 120px; max-width: 120px;">Số chênh lệch
                                    giữa 2 tháng (T{{
                                    formatMonth(selectedMonth) }} vs T{{ formatMonth(previousMonth) }})</td>
                                <td class="text-xs-center font-weight-bold"
                                    style="background-color: #FCD6CC; min-width: 120px; max-width: 120px;">Số chênh lệch
                                    giữa 2 tháng (T{{
                                    formatMonth(previousMonth) }} vs T{{ formatMonth(twoMonthsAgo) }})</td>
                                <td class="text-xs-center font-weight-bold"
                                    style="background-color: #FCD6CC; min-width: 100px; max-width: 100px;">Số chênh lệch
                                    vs TB</td>
                                <td class="text-xs-center font-weight-bold"
                                    style="background-color: #FCD6CC; min-width: 120px; max-width: 120px;">Tỷ lệ chênh
                                    lệch giữa 2 tháng</td>
                                <td class="text-xs-center font-weight-bold"
                                    style="background-color: #FCD6CC; min-width: 60px; max-width: 60px;">Tỷ lệ CL vs TB
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td class="text-xs-center text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }">
                                    {{ props.item.building }}
                                </td>
                                <td class="text-xs-center text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }">
                                    {{ props.item.customer_code }}
                                </td>
                                <td class="text-xs-right text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }">
                                    {{ Math.round(props.item.two_months_ago_consumption) | formatNumber }}
                                </td>
                                <td class="text-xs-right text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }">
                                    {{ Math.round(props.item.previous_month_consumption) | formatNumber }}
                                </td>
                                <td class="text-xs-right text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }">
                                    {{ Math.round(props.item.current_month_consumption) | formatNumber }}
                                </td>
                                <td class="text-xs-right text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }">
                                    {{ Math.round(props.item.average_consumption) | formatNumber }}
                                </td>
                                <td class="text-xs-right text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }"
                                    style="background-color: #FCD6CC;">
                                    {{ Math.round(props.item.diff_current_vs_prev) | formatNumber }}
                                </td>
                                <td class="text-xs-right text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }"
                                    style="background-color: #FCD6CC;">
                                    {{ Math.round(props.item.diff_prev_vs_two_months_ago) | formatNumber }}
                                </td>
                                <td class="text-xs-right text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }"
                                    style="background-color: #FCD6CC;">
                                    {{ Math.round(props.item.diff_vs_average) | formatNumber }}
                                </td>
                                <td class="text-xs-right text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }"
                                    style="background-color: #FCD6CC;">
                                    {{ props.item.percentage_diff_current_vs_prev !== null ?
                                    (props.item.percentage_diff_current_vs_prev).toFixed(1) + '%' : '' }}
                                </td>
                                <td class="text-xs-right text-no-wrap"
                                    :class="{ 'font-weight-bold': props.item.isTotalRow }"
                                    style="background-color: #FCD6CC;">
                                    {{ props.item.percentage_diff_vs_average !== null ?
                                    (props.item.percentage_diff_vs_average).toFixed(1) + '%' : '' }}
                                </td>
                            </tr>
                        </template>
                    </template>

                    <template slot="no-data">
                        Không có dữ liệu
                    </template>
                </v-data-table>
            </div>
        </v-container>
    </div>
</template>

<script>
import api from 'Api';
import _ from 'lodash'
import { INTERNAL_UTILITY_CONSUMER_TYPE, list_building } from 'Constants/db-config';
import { buildParamQuery, formatNumber } from "Helpers";
import moment from 'moment';

export default {
    name: 'so-sanh-dien-nuoc',
    data() {
        return {
            textareaKey: 0,
            loader: false,
            search: '',
            billType: 'Điện',
            selectedMonth: moment().format('YYYY-MM'),
            menu_month_picker: false,
            formatNumber,
            currentMonthData: { rawExtractedData: [], tenantAnalysisData: [] },
            previousMonthData: { rawExtractedData: [], tenantAnalysisData: [] },
            twoMonthsAgoData: { rawExtractedData: [], tenantAnalysisData: [] },
            list_building,
            moment,
            INTERNAL_UTILITY_CONSUMER_TYPE,
            notes: '',
            notesLoading: false,
        };
    },
    computed: {
        previousMonth() {
            if (!this.selectedMonth) return null;
            return moment(this.selectedMonth, 'YYYY-MM').subtract(1, 'months').format('YYYY-MM');
        },
        twoMonthsAgo() {
            if (!this.selectedMonth) return null;
            return moment(this.selectedMonth, 'YYYY-MM').subtract(2, 'months').format('YYYY-MM');
        },
        formatMonth() {
            return (monthString) => {
                if (!monthString) return '';
                return moment(monthString, 'YYYY-MM').format('MM');
            };
        },
        typeCode() {
            return this.billType === 'Nước' ? 'W' : 'E';
        },

        getProcessedBuildingConsumption() {
            return (rawData, tenantData) => {
                const buildingGroups = {};

                this.list_building.map(item => item.value).forEach(buildingName => {
                    buildingGroups[buildingName] = {
                        total_consumption: 0,
                    };

                    const currentTenantConsumption = tenantData
                        .filter(item => item.building === buildingName)
                        .reduce((sum, item) => sum + (item.consumption || 0), 0);

                    const buildingStateData = rawData.find(data => data.building === buildingName);

                    let washingConsumption = 0;
                    let securityConsumption = 0;

                    if (buildingStateData) {
                        washingConsumption = buildingStateData.internalBills
                            .filter(bill => bill.consumer_type && bill.consumer_type.toLowerCase().includes(this.INTERNAL_UTILITY_CONSUMER_TYPE.WASHING_MACHINE.toLowerCase()))
                            .reduce((sum, bill) => sum + (bill.consumption || 0), 0);
                        securityConsumption = buildingStateData.internalBills
                            .filter(bill => bill.consumer_type && bill.consumer_type.toLowerCase().includes(this.INTERNAL_UTILITY_CONSUMER_TYPE.SECURITY_GUARD.toLowerCase()))
                            .reduce((sum, bill) => sum + (bill.consumption || 0), 0);
                    }
                    buildingGroups[buildingName].total_consumption = currentTenantConsumption + washingConsumption + securityConsumption;
                });
                return buildingGroups;
            };
        },

        currentMonthBuildingConsumption() {
            return this.getProcessedBuildingConsumption(this.currentMonthData.rawExtractedData, this.currentMonthData.tenantAnalysisData);
        },
        previousMonthBuildingConsumption() {
            return this.getProcessedBuildingConsumption(this.previousMonthData.rawExtractedData, this.previousMonthData.tenantAnalysisData);
        },
        twoMonthsAgoBuildingConsumption() {
            return this.getProcessedBuildingConsumption(this.twoMonthsAgoData.rawExtractedData, this.twoMonthsAgoData.tenantAnalysisData);
        },
        
        buildingCustomerCodes() {
            const customerCodeMap = {};
            
            this.list_building.map(item => item.value).forEach(buildingName => {
                let customerCode = '';
                
                // Thử lấy từ tháng hiện tại trước
                const currentMonthStateData = this.currentMonthData.rawExtractedData.find(d => d.building === buildingName);
                if (currentMonthStateData && currentMonthStateData.stateBills && currentMonthStateData.stateBills.length > 0) {
                    customerCode = currentMonthStateData.stateBills[0].customer_code || '';
                } else {
                    // Nếu không có, thử lấy từ tháng trước
                    const previousMonthStateData = this.previousMonthData.rawExtractedData.find(d => d.building === buildingName);
                    if (previousMonthStateData && previousMonthStateData.stateBills && previousMonthStateData.stateBills.length > 0) {
                        customerCode = previousMonthStateData.stateBills[0].customer_code || '';
                    } else {
                        // Nếu không có, thử lấy từ 2 tháng trước
                        const twoMonthsAgoStateData = this.twoMonthsAgoData.rawExtractedData.find(d => d.building === buildingName);
                        if (twoMonthsAgoStateData && twoMonthsAgoStateData.stateBills && twoMonthsAgoStateData.stateBills.length > 0) {
                            customerCode = twoMonthsAgoStateData.stateBills[0].customer_code || '';
                        }
                    }
                }
                
                customerCodeMap[buildingName] = customerCode;
            });
            
            return customerCodeMap;
        },

        processedItems() {
            const items = [];

            this.list_building.map(item => item.value).forEach(buildingName => {
                const currentMonthCons = this.currentMonthBuildingConsumption[buildingName] ? this.currentMonthBuildingConsumption[buildingName].total_consumption : 0;
                const previousMonthCons = this.previousMonthBuildingConsumption[buildingName] ? this.previousMonthBuildingConsumption[buildingName].total_consumption : 0;
                const twoMonthsAgoCons = this.twoMonthsAgoBuildingConsumption[buildingName] ? this.twoMonthsAgoBuildingConsumption[buildingName].total_consumption : 0;

                const averageConsumption = (currentMonthCons + previousMonthCons + twoMonthsAgoCons) / 3;

                const diffCurrentVsPrev = currentMonthCons - previousMonthCons;
                const diffPrevVsTwoMonthsAgo = previousMonthCons - twoMonthsAgoCons;
                const diffVsAverage = currentMonthCons - averageConsumption;

                const percentageDiffCurrentVsPrev = previousMonthCons !== 0 ? (diffCurrentVsPrev / previousMonthCons * 100) : null;
                const percentageDiffVsAverage = averageConsumption !== 0 ? (diffVsAverage / averageConsumption * 100) : null;

                let customerCode = this.buildingCustomerCodes[buildingName] || '';
                
                // Nếu không có customer_code từ API, hiển thị tên building
                if (!customerCode) {
                    const buildingConfig = this.list_building.find(b => b.value === buildingName);
                    customerCode = buildingConfig ? buildingConfig.text : buildingName;
                }

                items.push({
                    building: buildingName,
                    customer_code: customerCode,
                    current_month_consumption: currentMonthCons,
                    previous_month_consumption: previousMonthCons,
                    two_months_ago_consumption: twoMonthsAgoCons,
                    average_consumption: averageConsumption,
                    diff_current_vs_prev: diffCurrentVsPrev,
                    diff_prev_vs_two_months_ago: diffPrevVsTwoMonthsAgo,
                    diff_vs_average: diffVsAverage,
                    percentage_diff_current_vs_prev: percentageDiffCurrentVsPrev,
                    percentage_diff_vs_average: percentageDiffVsAverage,
                    isFirstHeaderRow: false,
                    isTotalRow: false,
                });
            });

            return items;
        },
        totalRow() {
            const totalCurrentMonthCons = this.processedItems.reduce((sum, item) => sum + item.current_month_consumption, 0);
            const totalPreviousMonthCons = this.processedItems.reduce((sum, item) => sum + item.previous_month_consumption, 0);
            const totalTwoMonthsAgoCons = this.processedItems.reduce((sum, item) => sum + item.two_months_ago_consumption, 0);

            const totalAverageConsumption = (totalCurrentMonthCons + totalPreviousMonthCons + totalTwoMonthsAgoCons) / 3;

            const totalDiffCurrentVsPrev = totalCurrentMonthCons - totalPreviousMonthCons;
            const totalDiffPrevVsTwoMonthsAgo = totalPreviousMonthCons - totalTwoMonthsAgoCons;
            const totalDiffVsAverage = totalCurrentMonthCons - totalAverageConsumption;

            const totalPercentageDiffCurrentVsPrev = totalPreviousMonthCons !== 0 ? (totalDiffCurrentVsPrev / totalPreviousMonthCons * 100) : null;
            const totalPercentageDiffVsAverage = totalAverageConsumption !== 0 ? (totalDiffVsAverage / totalAverageConsumption * 100) : null;

            return {
                building: 'TỔNG',
                customer_code: '',
                current_month_consumption: totalCurrentMonthCons,
                previous_month_consumption: totalPreviousMonthCons,
                two_months_ago_consumption: totalTwoMonthsAgoCons,
                average_consumption: totalAverageConsumption,
                diff_current_vs_prev: totalDiffCurrentVsPrev,
                diff_prev_vs_two_months_ago: totalDiffPrevVsTwoMonthsAgo,
                diff_vs_average: totalDiffVsAverage,
                percentage_diff_current_vs_prev: totalPercentageDiffCurrentVsPrev,
                percentage_diff_vs_average: totalPercentageDiffVsAverage,
                isTotalRow: true,
                isFirstHeaderRow: false,
            };
        },
        displayingItems() {
            const items = [];
            items.push({ isFirstHeaderRow: true });

            const filteredItems = this.processedItems.filter(item => {
                if (!this.search) return true;
                return item.building.toLowerCase().includes(this.search.toLowerCase()) ||
                    (item.customer_code && item.customer_code.toLowerCase().includes(this.search.toLowerCase()));
            });

            if (filteredItems.length > 0) {
                items.push(...filteredItems);
                items.push(this.totalRow);
            }

            return items;
        },
        rooms() {
            return this.$store.state.app.rooms;
        }
    },
    watch: {
        selectedMonth: 'fetchData',
        billType: 'fetchData',
    },
    mounted() {
        this.fetchData();

        this.debouncedResize = _.debounce(() => {
            this.textareaKey++
        }, 100)

        window.addEventListener('resize', this.onResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        onResize() {
            this.debouncedResize()
        },
        async fetchData() {
            if (!this.selectedMonth || !this.billType) {
                this.currentMonthData = { rawExtractedData: [], tenantAnalysisData: [] };
                this.previousMonthData = { rawExtractedData: [], tenantAnalysisData: [] };
                this.twoMonthsAgoData = { rawExtractedData: [], tenantAnalysisData: [] };
                return;
            }
            this.loader = true;

            await this.fetchNotes();

            const months = [
                { date: moment(this.selectedMonth, 'YYYY-MM'), key: 'currentMonthData' },
                { date: moment(this.previousMonth, 'YYYY-MM'), key: 'previousMonthData' },
                { date: moment(this.twoMonthsAgo, 'YYYY-MM'), key: 'twoMonthsAgoData' }
            ];

            const fetchDataPromises = months.map(async ({ date, key }) => {
                const monthStr = date.format('YYYY-MM');
                const startOfMonth = date.startOf('month').format('YYYY-MM-DD');
                const endOfMonth = date.endOf('month').format('YYYY-MM-DD');

                const rawParams = {
                    dateStart: startOfMonth,
                    dateEnd: endOfMonth,
                    type: this.billType,
                    month: monthStr
                };

                let analysisStartDate = startOfMonth;
                let analysisEndDate = endOfMonth;
                if (this.billType === 'Nước') {
                    const prevMonthForWater = moment(monthStr, 'YYYY-MM').subtract(1, 'month');
                    analysisStartDate = prevMonthForWater.date(12).format('YYYY-MM-DD');
                    analysisEndDate = date.date(11).format('YYYY-MM-DD');
                }

                const analysisParams = {
                    month: monthStr,
                    date_start: analysisStartDate,
                    date_end: analysisEndDate,
                    skip_previous_months_check: true
                };

                try {
                    const [rawResponse, tenantResponse] = await Promise.all([
                        api.getBillsCombinedByBuilding(buildParamQuery(rawParams)),
                        this.billType === 'Điện'
                            ? api.getElectricityConsumptionAnalysis(buildParamQuery(analysisParams))
                            : api.getWaterConsumptionAnalysis(buildParamQuery(analysisParams))
                    ]);

                    const processedRawData = rawResponse.data.data.map(item => {
                        if (item.building === "BMT") item.building = "MT";
                        return item;
                    });
                    const processedTenantData = (tenantResponse.data || tenantResponse).map(item => {
                        if (item.building === "BMT") item.building = "MT";
                        return item;
                    }).filter(item => this.rooms.find(room => room.room_id === item.room_id));

                    this[key] = {
                        rawExtractedData: processedRawData,
                        tenantAnalysisData: processedTenantData
                    };
                } catch (error) {
                    console.error(`Lỗi khi lấy dữ liệu cho tháng ${monthStr}:`, error);
                    this[key] = { rawExtractedData: [], tenantAnalysisData: [] };
                }
            });

            await Promise.all(fetchDataPromises);
            this.loader = false;
        },

        async fetchNotes() {
            try {
                const params = {
                    month: this.selectedMonth,
                    type: this.typeCode
                };

                const query = buildParamQuery(params);

                const response = await api.getElectricityWaterComparison(query);
                if (response.data && response.data.success) {
                    this.notes = response.data.data.notes || '';
                }
            } catch (error) {
                console.error('Lỗi khi lấy ghi chú:', error);
                this.notes = '';
            }
        },

        async saveNotes() {
            if (!this.selectedMonth || !this.billType) return;
            
            this.notesLoading = true;
            try {
                const postData = {
                    month: this.selectedMonth,
                    type: this.typeCode,
                    notes: this.notes
                };
                
                const response = await api.createOrUpdateElectricityWaterComparison(postData);
                if (response.data && response.data.success) {
                    swal.fire('Lưu ghi chú thành công',"", 'success')
                    this.fetchNotes();
                }
            } catch (error) {
                console.error('Lỗi khi lưu ghi chú:', error);
            } finally {
                this.notesLoading = false;
            }
        },


        exportDataToCSV() {
            if (!this.displayingItems.length || this.displayingItems.length <= 1) { // Exclude header row from check
                alert('Không có dữ liệu để xuất CSV.');
                return;
            }

            const headerRow1 = [
                "TÒA NHÀ", "MÃ KH",
                "SỐ LƯỢNG TIÊU THỤ", "", "", "",
                "CHÊNH LỆCH", "", "", "", ""
            ];
            const headerRow2 = [
                "", "",
                `Tháng ${this.formatMonth(this.twoMonthsAgo)}`,
                `Tháng ${this.formatMonth(this.previousMonth)}`,
                `Tháng ${this.formatMonth(this.selectedMonth)}`,
                "Trung bình 3 tháng gần nhất",
                `Số chênh lệch giữa 2 tháng (T${this.formatMonth(this.selectedMonth)} vs T${this.formatMonth(this.previousMonth)})`,
                `Số chênh lệch giữa 2 tháng (T${this.formatMonth(this.previousMonth)} vs T${this.formatMonth(this.twoMonthsAgo)})`,
                "Số chênh lệch vs TB",
                "Tỷ lệ chênh lệch giữa 2 tháng",
                "Tỷ lệ CL vs TB"
            ];

            const dataToExport = this.displayingItems
                .filter(item => !item.isFirstHeaderRow) // Filter out the internal header row
                .map(item => [
                    item.building,
                    item.customer_code,
                    item.two_months_ago_consumption,
                    item.previous_month_consumption,
                    item.current_month_consumption,
                    item.average_consumption,
                    item.diff_current_vs_prev,
                    item.diff_prev_vs_two_months_ago,
                    item.diff_vs_average,
                    item.percentage_diff_current_vs_prev !== null ? item.percentage_diff_current_vs_prev + '%' : '',
                    item.percentage_diff_vs_average !== null ? item.percentage_diff_vs_average + '%' : '',
                ]);

            const csvContent = [headerRow1, headerRow2, ...dataToExport].map(e => e.join(",")).join("\n");
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            const fileName = `So_sanh_${this.billType}_3_thang_${this.formatMonth(this.twoMonthsAgo)}-${this.formatMonth(this.selectedMonth)}.csv`;
            link.setAttribute("download", fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    }
};
</script>

<style scoped>
.table-container {
  overflow-x: auto;
}

.table-container table {
  border-collapse: collapse;
}

td, th {
  border: 1px solid #e0e0e0;
  padding: 8px 16px;
  background-color: white;
  word-wrap: break-word;
  white-space: normal;
}

.text-wrap td {
  white-space: normal;
  word-wrap: break-word;
}

td:nth-child(1),
td:nth-child(2) {
  position: sticky;
  z-index: 40;
  background-color: white;
}

td:nth-child(1) {
  left: 0;
  min-width: 80px;
  max-width: 80px;
}

td:nth-child(2) {
  left: 80px;
  min-width: 120px;
  max-width: 120px;
}

tr.sticky-header td:nth-child(1),
tr.sticky-header td:nth-child(2) {
  z-index: 50;
}

.fw-bold {
    font-weight: bold;
}
</style>